export const AlertTypeEnum = {
	INFO: "info",
	ERROR: "error",
	SUCCESS: "success",
	WARNING: "warning",
};
